export default "__VITE_ASSET__BFnQb$eS__"